import { toneVariant, useCompanionNoun } from '@/utils/personalization'
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import type { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  { emoji: '📅', title: 'pages.onboarding.frequency.daily', value: 'daily' },
  { emoji: '📆', title: 'pages.onboarding.frequency.weekly', value: 'weekly' },
  {
    emoji: '🆘',
    title: 'pages.onboarding.frequency.asneeded',
    value: 'asneeded',
  },
  {
    emoji: '🏖️',
    title: 'pages.onboarding.frequency.weekends',
    value: 'weekends',
  },
]

export default function FrequencyQuestionPage() {
  const noun = useCompanionNoun()

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title={toneVariant('pages.onboarding.frequency.title')}
      subtitle={toneVariant('pages.onboarding.frequency.subtitle')}
      translationInterpolation={{ noun }}
    />
  )
}
